import React, { useState, useEffect } from "react";
import {
  Page,
  Icon,
  Link,
  Button,
  Swiper as SwiperComponent,
  SwiperSlide,
  f7,
  List,
  ListItem,
} from "framework7-react";
import axios from "axios";
import {
  API_BASE_URL,
  API_AUTH,
  IMG_URL,
  GOOGLE_MAP_API_KEY,
} from "../globals";
import { useRef } from "react";

const SearchRestaurantPage = () => {
  const [restData, setRestData] = useState([]);
  const [searchKey, setSearchKey] = useState("");
  const [selectedRadio, setSelectedRadio] = useState("restaurant");
  const [buttonClicked, setButtonClicked] = useState(false);
  const [suggestion, setSuggestion] = useState("");
  const [details, setDetails] = useState(null);
  const [cuisine, setCuisine] = useState("");
  const [cuisineType, setCuisineType] = useState(0);
  const [googleSuggestedRestaurants, setGoogleSuggestedRestaurants] = useState(
    []
  );
  const [suggestedRestaurants, setSuggestedRestaurants] = useState([]);
  const [isSearchNearBy, setIsSearchNearBy] = useState(false);
  const [coordinates, setCoordinates] = useState(null);
  const [radius, setRadius] = useState(5);
  const [nextPageToken, setNextPageToken] = useState();

  useEffect(() => {
    // axios.get(API_BASE_URL + 'restaurantdetails', {
    //     headers: {
    //       'Authorization': 'Basic ' + API_AUTH
    //     }
    //   })
    //   .then(response => setRestData(response.data))
    //   .catch(error => console.log(error));
  }, []);

  const handleTextAreaChange = (event) => {
    setSuggestion(event.target.value);
  };

  const handleRadioChange = (value) => {
    setSelectedRadio(value);
    setSearchKey("");
    setRestData([]);
    setGoogleSuggestedRestaurants([]);
    setCuisineType(0);
  };

  const getUserGeolocationDetails = () => {
    axios
      .get(
        "https://geolocation-db.com/json/b072f2c0-9d28-11ee-9883-9fb240147f5c"
      )
      .then((response) => {
        setDetails(response.data);
        console.log("details", details);
      })
      .catch((error) => console.log(error));
  };

  const getCuisineType = () => {
    axios
      .get(API_BASE_URL + "cuisintype", {
        headers: {
          Authorization: "Basic " + API_AUTH,
        },
      })
      .then((response) => {
        setCuisine(response.data);
      })
      .catch((error) => console.log(error));
  };

  const getCurrentCoordinates = () => {
    navigator.geolocation.getCurrentPosition((position) => {
      setCoordinates(position.coords);
    });
  };
  useEffect(() => {
    getUserGeolocationDetails();
    getCuisineType();
    // if (!coordinates) {
    getCurrentCoordinates();
    // }
  }, []);

  const searchNearbyRestaurants = async () => {
    try {
      if (coordinates.latitude && coordinates.longitude) {
        const googleResults = await axios.get(
          API_BASE_URL +
            `googleapiplaceidsearch?keyword=restaurant+${searchKey}&location=${
              coordinates.latitude
            }%2C${coordinates.longitude}&radius=${radius * 1000}`,
          {
            headers: {
              Authorization: "Basic " + API_AUTH,
            },
          }
        );

        const restaurants = googleResults?.data?.data?.results?.filter(
          (rest) =>
            rest.types.includes("restaurant") &&
            rest.business_status !== "CLOSED_TEMPORARILY"
        );
        setNextPageToken(googleResults?.data?.data?.next_page_token);
        setGoogleSuggestedRestaurants(restaurants);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const searchByRestaurantName = async () => {
    try {
      const googleResults = await axios.get(
        API_BASE_URL +
          `googleapiplacesearch?query=restaurant+${searchKey}${
            coordinates
              ? `&location=${coordinates.latitude}%2C${coordinates.longitude}&rankby=distance`
              : ""
          }`,
        {
          headers: {
            Authorization: "Basic " + API_AUTH,
          },
        }
      );

      const restaurants = googleResults?.data?.data?.results?.filter(
        (rest) =>
          rest.types.includes("restaurant") &&
          rest.business_status !== "CLOSED_TEMPORARILY"
      );
      setNextPageToken(googleResults?.data?.data?.next_page_token);
      setGoogleSuggestedRestaurants(restaurants);
    } catch (error) {
      console.log(error);
    }
  };
  console.log("nextPageToken", nextPageToken);
  const topRef = useRef(null);
  const handlePagination = async () => {
    if (nextPageToken == "") {
      return false;
    } else {
      if (isSearchNearBy) {
        try {
          if (coordinates.latitude && coordinates.longitude) {
            const googleResults = await axios.get(
              API_BASE_URL +
                `googleapiplaceidsearch?keyword=restaurant+${searchKey}&location=${
                  coordinates.latitude
                }%2C${coordinates.longitude}&radius=${
                  radius * 1000
                }&pagetoken=${nextPageToken}`,
              {
                headers: {
                  Authorization: "Basic " + API_AUTH,
                },
              }
            );

            const restaurants = googleResults?.data?.data?.results?.filter(
              (rest) =>
                rest.types.includes("restaurant") &&
                rest.business_status !== "CLOSED_TEMPORARILY"
            );
            setNextPageToken(googleResults?.data?.data?.next_page_token);
            setGoogleSuggestedRestaurants(restaurants);
            topRef.current.scrollIntoView({ behavior: "smooth" });
          }
        } catch (error) {
          console.log(error);
        }
      } else {
        try {
          const googleResults = await axios.get(
            API_BASE_URL +
              `googleapiplacesearch?query=restaurant+${searchKey}${
                coordinates
                  ? `&location=${coordinates.latitude}%2C${coordinates.longitude}&rankby=distance&pagetoken=${nextPageToken}`
                  : ""
              }`,
            {
              headers: {
                Authorization: "Basic " + API_AUTH,
              },
            }
          );

          const restaurants = googleResults?.data?.data?.results?.filter(
            (rest) =>
              rest.types.includes("restaurant") &&
              rest.business_status !== "CLOSED_TEMPORARILY"
          );

          setNextPageToken(googleResults?.data?.data?.next_page_token);
          setGoogleSuggestedRestaurants(restaurants);

          topRef.current.scrollIntoView({ behavior: "smooth" });
        } catch (error) {
          console.log(error);
        }
      }
    }
  };

  const searchByName = async (e) => {
    e.preventDefault();
    try {
      if (isSearchNearBy) {
        await searchNearbyRestaurants();
      } else if (searchKey) {
        await searchByRestaurantName();
      }
      if (searchKey === "" && cuisineType == 0) {
        return false;
      }

      const response = await axios.get(API_BASE_URL + "restsearchbyname", {
        headers: {
          Authorization: "Basic " + API_AUTH,
        },
        params: {
          search: selectedRadio == "cuisine" ? cuisineType : searchKey,
          type: selectedRadio,
        },
      });

      setRestData(response.data);
      console.log(response.data);
      setButtonClicked(false);
    } catch (error) {
      console.log(error);
      setRestData([]);
      setButtonClicked(true);
    }
  };
  const handleButtonClick = (event) => {
    const id = localStorage.getItem("id") ? localStorage.getItem("id") : null;
    const headers = {
      Authorization: "Basic " + API_AUTH,
    };
    const SuggestionData = {
      cust_id: id,
      restaurant_details: suggestion,
      restaurant_name: suggestion,
      device_details: details,
    };
    if (SuggestionData.restaurant_details == "") {
      alert("Please Enter Your Suggestion");
    } else {
      axios.post(API_BASE_URL + "suggested_restaurants", SuggestionData, {
        headers,
      });
      console.log("Button clicked");
      setSuggestion("");
      setSearchKey("");
      alert("Request Submitted.");
    }
  };

  const handleAddRestaurant = (restaurantDetails) => {
    const addressStyle = "margin-top: 10px;";
    const value = `<div><h5>${
      restaurantDetails.name
    }</h5><p style="${addressStyle}">${
      restaurantDetails.formatted_address
        ? restaurantDetails.formatted_address
        : restaurantDetails.vicinity
    }</p></div>`;
    setSuggestedRestaurants((prevState) => [
      ...prevState,
      restaurantDetails.place_id,
    ]);
    const id = localStorage.getItem("id") ? localStorage.getItem("id") : null;
    const headers = {
      Authorization: "Basic " + API_AUTH,
    };
    const SuggestionData = {
      cust_id: id,
      restaurant_name: restaurantDetails.name,
      restaurant_details: value,
      device_details: details,
    };
    if (SuggestionData.restaurant_details == "") {
      alert("Please Enter Your Suggestion");
    } else {
      axios.post(API_BASE_URL + "suggested_restaurants", SuggestionData, {
        headers,
      });
      setSuggestion("");
      setSearchKey("");
      alert("Request Submitted.");
    }
  };

  // useEffect(() => {
  //   const handleMessage = (event) => {
  //     const message = event.data;
  //     const latitude = message?.coords?.latitude;
  //     const longitude = message?.coords?.longitude;
  //     if (latitude && longitude) {
  //       setCoordinates({ latitude, longitude });
  //     }
  //   };

  //   window?.ReactNativeWebView?.postMessage("Search restaurant page");
  //   window.addEventListener("message", handleMessage);

  //   return () => {
  //     window.removeEventListener("message", handleMessage);
  //   };
  // }, []);

  return (
    <Page className="bg-white">
      <div className="container container-table">
        <div className="row vertical-center-row col-md-12 col-md-offset-12">
          <header className="section-t-space">
            <div className="custom-container p-0">
              <div className="container-lg header-panel p-0">
                <Link href="#" back>
                  <Icon
                    ios="material:keyboard_arrow_left"
                    aurora="material:keyboard_arrow_left"
                    md="material:keyboard_arrow_left"
                    className="theme-dark"
                    backLink="Back"
                  ></Icon>
                </Link>
                <h2>Search</h2>
                {/* <Link href="#"><Icon ios="material:edit" aurora="material:edit" md="material:edit" className='theme-dark'></Icon></Link> */}
              </div>
            </div>
          </header>

          {/* <Navbar title="Eatbids" noShadow>
      <NavRight>
        <Link href="/cart/" transition="f7-parallax">
          <Icon material="shopping_bag" iconIos="f7:shopping_bag" color='purple'>
            <Badge color="teal">5</Badge>
          </Icon>
        </Link>
      </NavRight>
    </Navbar> */}
          <section className="search-section section-t-space profile-form mt-3">
            <List>
              <ListItem
                radio
                value="restaurant"
                name="demo-radio"
                defaultChecked
                title="Search By Restaurant"
                onChange={() => handleRadioChange("restaurant")}
              ></ListItem>
              <ListItem
                radio
                value="cuisine"
                name="demo-radio"
                title="Search By Cuisine Type"
                onChange={() => handleRadioChange("cuisine")}
              ></ListItem>
            </List>

            <div className="custom-container p-0">
              <form
                className="auth-form search-head"
                onSubmit={(e) => searchByName(e)}
              >
                <div className="form-group">
                  {selectedRadio === "restaurant" ? (
                    <div className="display-flex flex-direction-column width-100">
                      <div className="form-input w-100">
                        <input
                          value={searchKey}
                          type="text"
                          className="form-control search"
                          onChange={(e) => {
                            setSearchKey(e.target.value);
                            setButtonClicked(false);
                            setRestData([]);
                            setGoogleSuggestedRestaurants([]);
                          }}
                          id="inputusername"
                          placeholder={
                            selectedRadio == "restaurant"
                              ? "Restaurant or Zip code"
                              : " Recipe"
                          }
                          autoFocus
                        />
                        <Icon
                          ios="material:search"
                          aurora="material:search"
                          md="material:search"
                          size={22}
                        ></Icon>
                      </div>
                      <div
                        className="display-flex mt-3"
                        style={{ flexWrap: "wrap" }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            height: "42px",
                          }}
                        >
                          <input
                            style={{
                              width: "20px",
                              height: "20px",
                              border: !isSearchNearBy
                                ? "2px solid var(--f7-radio-inactive-color)"
                                : "var(--f7-radio-border-width) solid var(--f7-radio-inactive-color)",
                              marginBottom: !isSearchNearBy ? "5px" : "unset",
                            }}
                            className="form-check-input"
                            type="checkbox"
                            value={isSearchNearBy}
                            onClick={() =>
                              setIsSearchNearBy((prevState) => !prevState)
                            }
                          />
                          <label
                            className="form-check-label"
                            style={{
                              marginLeft: "10px",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            Search Nearby Restaurants within
                          </label>
                        </div>
                        <div>
                          <div className="form-input w-100 display-flex noscroll">
                            <input
                              style={{
                                maxWidth: "50px",
                                textAlign: "center",
                                padding: "10px",
                                background: "unset",
                              }}
                              value={radius}
                              type="number"
                              id="inputusername"
                              className="form-control search"
                              onChange={(event) =>
                                setRadius(event?.target?.value)
                              }
                              autoFocus
                            />
                            <label
                              className="form-check-label"
                              style={{
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              Miles
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="form-input  w-100">
                      <select
                        className="form-select form-control"
                        required
                        validate
                        errorMessage="Please select State"
                        name="menu_type"
                        style={{ width: "100%" }}
                        value={cuisineType}
                        onChange={(e) => {
                          setCuisineType(e.target.value);
                          setRestData([]);
                        }}
                      >
                        <option value="0" selected>
                          Select Cuisine Type
                        </option>
                        {cuisine &&
                          cuisine.map((item) => (
                            <option key={item.id} value={item.id}>
                              {item.cuisine_name}
                            </option>
                          ))}
                      </select>
                    </div>
                  )}
                </div>
                <div className="">
                  <a
                    type="button"
                    className="btn btn-success w-100"
                    onClick={(e) => searchByName(e)}
                  >
                    Search
                  </a>
                </div>
              </form>
            </div>
          </section>

          <section className="section-t-space mt-2 mb-3  " ref={topRef}>
            {selectedRadio === "restaurant" ? (
              restData.length === 0 &&
              googleSuggestedRestaurants.length === 0 &&
              searchKey.trim() !== "" &&
              buttonClicked ? (
                <div
                  className="custom-not-found"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <p
                    style={{
                      color: "black",
                      fontSize: "16px",
                      textAlign: "center",
                    }}
                  >
                    Let us know if your favorite restaurant is not listed here
                  </p>
                  <textarea
                    cols={30}
                    rows={10}
                    id="customInput"
                    value={suggestion}
                    onChange={handleTextAreaChange}
                    style={{
                      border: "0.5px solid grey",
                      width: "350px",
                      height: "125px",
                      resize: "none",
                      borderRadius: "5px",
                      marginTop: "20px",
                      padding: "10px",
                      borderColor: "#d7d7d7",
                    }}
                    placeholder="Please share the name of the restaurant and location/zipcode"
                  ></textarea>
                  <Button
                    id="submitButton"
                    style={{
                      width: "150px",
                      height: "35px",
                      color: "black",
                      backgroundColor: "#ffc107",
                      border: "none",
                      outline: "none",
                      marginTop: "15px",
                      borderRadius: "4px",
                      fontSize: "14px",
                      fontWeight: "500",
                      textTransform: "none",
                    }}
                    onClick={handleButtonClick}
                  >
                    Request
                  </Button>
                </div>
              ) : (
                <div className="custom-container p-0">
                  <div className="container p-0">
                    <div className="row gy-3">
                      {restData.map((restdetail) => (

<div
                          className="bid-web-view-div"
                          style={{
                            marginBottom: "10px",
                          }}
                        >
                          <a href={`/restaurantdetail/${restdetail.rest_id}/`}>
                            <div className="vertical-product-box restaurant-product-box">
                              <div className="vertical-box-img">
                                <a
                                  href={`/restaurantdetail/${restdetail.rest_id}/`}
                                >
                                  {restdetail.rest_img !== null ? (
                                    <img
                                      className="img-fluid img"
                                      src={`${IMG_URL}${restdetail.rest_img}`}
                                      alt={restdetail.rest_name}
                                      style={{ height: "120px", width: "100%" }}
                                    />
                                  ) : (
                                    <img
                                      className="img-fluid img"
                                      src={require("./../images/no-image.png")}
                                      alt={restdetail.rest_name}
                                      style={{ height: "120px", width: "100%" }}
                                    />
                                  )}
                                </a>
                                <div className="like-icon">
                                  {/* <i className="ri-heart-3-line outline-icon" /> */}
                                  <i className="ri-heart-3-fill fill-icon" />
                                  <div className="effect-group">
                                    <span className="effect" />
                                    <span className="effect" />
                                    <span className="effect" />
                                    <span className="effect" />
                                    <span className="effect" />
                                  </div>
                                </div>
                              </div>
                              <div className="vertical-box-details">
                                <div className="vertical-box-head">
                                  <div className="restaurant">
                                    <a
                                      href={`/restaurantdetail/${restdetail.rest_id}/`}
                                    >
                                      <h5>{restdetail.rest_name}</h5>
                                    </a>
                                  </div>
                                  <h6 className="food-items text-capitalize">
                                    {restdetail.cuisine_type}
                                    {/* {restdetail.menu_details.map(
                                      (menu) => menu.menu_item_name + ", "
                                    )} */}
                                  </h6>
                                </div>
                                <div className="location-distance">
                                  <div className="location1">
                                    <h6 className="place text-dark">
                                      <Icon
                                        ios="material:location_on"
                                        aurora="material:location_on"
                                        md="material:location_on"
                                        size={16}
                                        className="text-success"
                                      ></Icon>{" "}
                                      {restdetail.add_lin_1}{" "}
                                      {restdetail.add_lin_2} {restdetail.city}{" "}
                                      {restdetail.state} {restdetail.zip_code}
                                    </h6>
                                    {/* <h6 className="pt-2 pb-2 text-dark">Start from <span className="text-danger">$95</span> for one tray</h6> */}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </a>
                        </div>
                      ))}
                      {restData.length !== 0 && (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",

                            marginBottom: "15px",
                          }}
                        >
                          <div
                            style={{
                              width: "90%",
                              height: "1.5px",
                              backgroundColor: "#EFEFEF",
                              borderRadius:"50%"
                            }}
                          ></div>
                        </div>
                      )}
                      {googleSuggestedRestaurants?.length > 0 && (
                        <>
                          <h3 className="mt-10">
                            Request to onboard your preferred restaurant below
                            to Eatbids
                          </h3>
                          {googleSuggestedRestaurants?.map((restdetail) => (
                            <div className="bid-web-view-div display-flex">
                              <div
                                className="vertical-product-box restaurant-product-box"
                                style={{ width: "80%" }}
                              >
                                <div className="vertical-box-img">
                                  {restdetail?.photos?.length > 0 ? (
                                    <img
                                      className="img-fluid img"
                                      src={`https://maps.googleapis.com/maps/api/place/photo?maxwidth=400&photoreference=${
                                        restdetail?.photos[0]?.photo_reference
                                      }&key=${encodeURIComponent(
                                        GOOGLE_MAP_API_KEY
                                      )}`}
                                      alt={restdetail.name}
                                      style={{
                                        height: "120px",
                                        width: "100%",
                                      }}
                                    />
                                  ) : (
                                    <img
                                      className="img-fluid img"
                                      src={require("./../images/no-image.png")}
                                      alt={restdetail.name}
                                      style={{
                                        height: "120px",
                                        width: "100%",
                                      }}
                                    />
                                  )}
                                  <div className="like-icon">
                                    <i className="ri-heart-3-fill fill-icon" />
                                    <div className="effect-group">
                                      <span className="effect" />
                                      <span className="effect" />
                                      <span className="effect" />
                                      <span className="effect" />
                                      <span className="effect" />
                                    </div>
                                  </div>
                                </div>
                                <div className="vertical-box-details">
                                  <div className="vertical-box-head">
                                    <div className="restaurant">
                                      <h5>{restdetail.name}</h5>
                                    </div>
                                  </div>
                                  <div className="location-distance">
                                    <div className="location1">
                                      <h6 className="place text-dark">
                                        <Icon
                                          ios="material:location_on"
                                          aurora="material:location_on"
                                          md="material:location_on"
                                          size={16}
                                          className="text-success"
                                        ></Icon>{" "}
                                        {restdetail.formatted_address
                                          ? restdetail.formatted_address
                                          : restdetail.vicinity}
                                      </h6>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="display-flex align-items-center justify-content-center"
                                style={{ width: "20%", marginLeft: "10px" }}
                              >
                                <Button
                                  id="submitButton"
                                  style={{
                                    height: "35px",
                                    color: "black",
                                    backgroundColor: "#ffc107",
                                    border: "none",
                                    outline: "none",
                                    marginTop: "15px",
                                    borderRadius: "4px",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                    textTransform: "none",
                                  }}
                                  disabled={suggestedRestaurants.includes(
                                    restdetail.place_id
                                  )}
                                  onClick={() =>
                                    handleAddRestaurant(restdetail)
                                  }
                                >
                                  Request
                                </Button>
                              </div>
                            </div>
                          ))}
                        </>
                      )}
                    </div>
                    {googleSuggestedRestaurants?.length > 0 &&
                      nextPageToken && (
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "center",
                            marginTop: "10px",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                            }}
                          >
                            <div
                              style={{
                                width: "70px",
                                height: "35px",
                                // border: "1px solid black",
                                backgroundColor: "#ffc107",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                borderRadius: "4px",
                              }}
                            >
                              <Link onClick={handlePagination} reload>
                                <h6
                                  style={{
                                    color: "black",
                                    // marginTop: "3px",
                                    marginLeft: "5px",
                                  }}
                                >
                                  Next
                                </h6>
                                <Icon
                                  ios="material:keyboard_arrow_right"
                                  aurora="material:keyboard_arrow_right"
                                  md="material:keyboard_arrow_right"
                                  className="theme-dark"
                                  backLink="Back"
                                  style={{ color: "black" }}
                                ></Icon>
                              </Link>
                            </div>
                          </div>
                        </div>
                      )}
                  </div>
                </div>
              )
            ) : (
              <div className="custom-container p-0">
                <div className="title">
                  {/* <h3 className="mt-0">Explore Restaurants</h3> */}
                </div>
                <div className="container p-0">
                  <div className="row gy-3">
                    {restData.map((restdetail) => (
                      <div className="bid-web-view-div">
                        <a href={`/restaurantdetail/${restdetail.rest_id}/`}>
                          <div className="vertical-product-box restaurant-product-box">
                            <div className="vertical-box-img">
                              <a
                                href={`/restaurantdetail/${restdetail.rest_id}/`}
                              >
                                {restdetail.rest_img !== null ? (
                                  <img
                                    className="img-fluid img"
                                    src={`${IMG_URL}${restdetail.rest_img}`}
                                    alt={restdetail.rest_name}
                                    style={{ height: "120px", width: "100%" }}
                                  />
                                ) : (
                                  <img
                                    className="img-fluid img"
                                    src={require("./../images/no-image.png")}
                                    alt={restdetail.rest_name}
                                    style={{ height: "120px", width: "100%" }}
                                  />
                                )}
                              </a>
                              <div className="like-icon">
                                {/* <i className="ri-heart-3-line outline-icon" /> */}
                                <i className="ri-heart-3-fill fill-icon" />
                                <div className="effect-group">
                                  <span className="effect" />
                                  <span className="effect" />
                                  <span className="effect" />
                                  <span className="effect" />
                                  <span className="effect" />
                                </div>
                              </div>
                            </div>
                            <div className="vertical-box-details">
                              <div className="vertical-box-head">
                                <div className="restaurant">
                                  <a
                                    href={`/restaurantdetail/${restdetail.rest_id}/`}
                                  >
                                    <h5>{restdetail.rest_name}</h5>
                                  </a>
                                </div>
                                <h6 className="food-items text-capitalize">
                                  {restdetail.menu_details.map(
                                    (menu) => menu.menu_item_name + ", "
                                  )}
                                </h6>
                              </div>
                              <div className="location-distance">
                                <div className="location1">
                                  <h6 className="place text-dark">
                                    <Icon
                                      ios="material:location_on"
                                      aurora="material:location_on"
                                      md="material:location_on"
                                      size={16}
                                      className="text-success"
                                    ></Icon>{" "}
                                    {restdetail.add_lin_1}{" "}
                                    {restdetail.add_lin_2} {restdetail.city}{" "}
                                    {restdetail.state} {restdetail.zip_code}
                                  </h6>
                                  {/* <h6 className="pt-2 pb-2 text-dark">Start from <span className="text-danger">$95</span> for one tray</h6> */}
                                </div>
                              </div>
                            </div>
                          </div>
                        </a>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}
          </section>
        </div>
      </div>
    </Page>
  );
};

export default SearchRestaurantPage;
